import { Injectable } from '@angular/core';
import { environment } from '@env';
import { Observable, Observer } from 'rxjs';

export interface ScriptModel {
    name: string;
    src: string;
    loaded: boolean;
}

@Injectable({ providedIn: 'root' })
export class ScriptService {
    availableScripts: { [key: string]: ScriptModel } = {
        googlemaps: {
            name: 'googlemaps',
            src: `https://maps.googleapis.com/maps/api/js?key=${environment.maps.apiKey}`,
            loaded: false,
        },
    };

    private scripts: Map<string, ScriptModel> = new Map();

    constructor() {}

    load(script: ScriptModel): Observable<ScriptModel> {
        return new Observable<ScriptModel>((observer: Observer<ScriptModel>) => {
            const existingScript = this.scripts.get(script.name);

            // Complete if already loaded
            if (existingScript && existingScript.loaded) {
                observer.next(existingScript);
                observer.complete();
            } else {
                // Add the script
                this.scripts.set(script.name, script);

                // Load the script
                let scriptElement = document.createElement('script');
                scriptElement.type = 'text/javascript';
                scriptElement.src = script.src;

                scriptElement.onload = () => {
                    script.loaded = true;
                    observer.next(script);
                    observer.complete();
                };

                scriptElement.onerror = (_: any) => {
                    observer.error("Couldn't load script " + script.src);
                };

                document.getElementsByTagName('body')[0].appendChild(scriptElement);
            }
        });
    }
}
